/**
 * Brands that sell Protega plans, for "Find your plan". Replace with an API list once the backend
 * exposes one (see backend-requests.md); ids are what the recovery request sends as `merchant`.
 * `orderId` describes the brand's order ID format when we know it, for an early, specific hint.
 */
export interface ProtectionBrand {
  id: string;
  name: string;
  orderId?: { pattern: RegExp; example: string };
}

export const PROTECTION_BRANDS: ProtectionBrand[] = [
  { id: 'eume', name: 'EUME', orderId: { pattern: /^#?\d{6}$/, example: '#100245' } },
  { id: 'izicart', name: 'izicart' },
  { id: 'adivaa', name: 'Adivaa' },
  { id: 'nestroots', name: 'Nestroots' },
  { id: 'mecturing', name: 'Mecturing' },
  { id: 'autofurnish', name: 'Autofurnish' },
  { id: 'urbanflux', name: 'Urban Flux' },
  { id: 'thebeachcompany', name: 'The Beach Company' },
];
